import React from 'react';
import { DefaultTag } from '../styles/globals';
import { THEME as theme } from '../styles/theme';

export const SurveyStatus: {
  [key: string]: string;
} = {
  draft: 'draft',
  scheduled: 'scheduled',
  live: 'live',
  closed: 'closed',
};

export const useStatus = () => {
  const chooseTagStyle = (status: string) => {
    switch (status) {
      case 'draft':
        return {
          fontColor: theme.colors.accent.blue[100],
          borderColor: theme.colors.accent.blue[100],
          backgroundColor: theme.colors.accent.blue[10],
        };
      case 'scheduled':
        return {
          fontColor: theme.colors.accent.blue[100],
          borderColor: theme.colors.accent.blue[100],
          backgroundColor: theme.colors.accent.blue[10],
        };
      case 'live':
        return {
          fontColor: theme.colors.accent.green[100],
          borderColor: theme.colors.accent.green[100],
          backgroundColor: theme.colors.accent.green[10],
        };
      case 'closed':
        return {
          fontColor: theme.colors.accent.green[100],
          borderColor: theme.colors.accent.green[100],
          backgroundColor: theme.colors.accent.green[10],
        };
      default:
        return {
          fontColor: theme.colors.accent.green[100],
          borderColor: theme.colors.accent.green[100],
          backgroundColor: theme.colors.accent.green[10],
        };
    }
  };

  const getStatusTag = (status: string) => {
    const { fontColor, backgroundColor, borderColor } = chooseTagStyle(status);
    return (
      <DefaultTag
        data-testid={`${status}-tag`}
        backgroundColor={backgroundColor}
        color={fontColor}
        borderColor={borderColor}
      >
        {SurveyStatus[status]}
      </DefaultTag>
    );
  };

  const getStatusKey = (status: string) =>
    Object.keys(SurveyStatus).filter(key => SurveyStatus[key] === status)[0];

  const getStatus = (status: string) => SurveyStatus[status];

  const getAppliedStatus = (applied: string) => applied.split(',').map(status => getStatus(status));

  return { getStatusTag, getStatusKey, getStatus, getAppliedStatus };
};
